var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _rect8, _rect9, _path2, _rect10, _rect11, _rect12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgOwnSpecification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 93,
    viewBox: "0 0 113 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    width: 72,
    height: 92,
    rx: 2,
    fill: "#D6E8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 20,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 67,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 27,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 34,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 52,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 59,
    width: 52,
    height: 3,
    rx: 1,
    fill: "#4B81AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 63C60 60.7909 61.7909 59 64 59H109C111.209 59 113 60.7909 113 63V81C113 83.2091 111.209 85 109 85H98.5L88.75 93V85H64C61.7909 85 60 83.2091 60 81V63Z",
    fill: "#3A8761"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 67,
    width: 37,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 74,
    width: 25,
    height: 3,
    rx: 1,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 12.7909 1.79086 11 4 11H65C67.2091 11 69 12.7909 69 15V41C69 43.2091 67.2091 45 65 45H29.75V55.5L18.5 45H4C1.79086 45 0 43.2091 0 41V15Z",
    fill: "#2F6086"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 20,
    width: 53,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 53,
    height: 3,
    rx: 1,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 34,
    width: 41,
    height: 3,
    rx: 1,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgOwnSpecification);
export default __webpack_public_path__ + "static/media/imgOwnSpecification.c1d2dd2c61406e7e5c5cdb34585e9232.svg";
export { ForwardRef as ReactComponent };